// ✅ Unified Checkout Handler – CLEAN STRUCTURE

if (!window.__checkoutHandlerInitialized) {
  window.__checkoutHandlerInitialized = true;

// ─────────────────────────────────────────
// 🔁 Global Declarations
// ─────────────────────────────────────────

let fallbackDisplayed = false;
let upsellDrawer = null;
let upsellAddBtn = null;
let cartDrawer = null;
let fallbackContainer = null;
let upsellHandled = false;
let fallbackCtaTimeout = null;
let cartItemsObserver = null;
let cartUpdateThrottleTimeout = null;
let lastCartItemCount = 0;

// ─────────────────────────────────────────
// 🔁 Utility Functions
// ─────────────────────────────────────────

function refreshGlobalElements() {
  upsellDrawer = document.getElementById('membership-upsell-drawer');
  cartDrawer = document.getElementById('CartDrawer');
  fallbackContainer = document.getElementById('fallback-cta');
  upsellAddBtn = upsellDrawer?.querySelector('button.add') || upsellAddBtn;
}

// Start Drawer State Manager

window.drawerState = { cartOpen: false, upsellOpen: false };

function hideFallbackCTA() {
  document.querySelectorAll('.fallback-cta').forEach(container => {
    container.classList.remove('fallback-ready');
    container.style.setProperty('display', 'none', 'important');
  });
}

function showFallbackCTA() {
  document.querySelectorAll('.fallback-cta').forEach(container => {
    container.classList.add('fallback-ready');
    container.style.setProperty('display', 'block', 'important');
  });
}

function evaluateCTAVisibility(forceShow = false) {
  const fallbackContainers = document.querySelectorAll('.fallback-cta');
  if (!fallbackContainers.length) return;

  const cartDrawer = document.querySelector('cart-drawer');
  const cartVisible = cartDrawer?.classList.contains('active');
  const showCTA = forceShow || (cartVisible && !window.drawerState.upsellOpen);

  fallbackContainers.forEach(container => {
    container.classList.toggle('fallback-ready', showCTA);
    container.style.setProperty('display', showCTA ? 'block' : 'none', 'important');
  });

  console.log('[CTA] Visibility evaluated:', showCTA);
}

function setDrawerState(newState) {
  console.log('[DrawerState] Previous:', window.drawerState, 'New:', newState);

  const wasCartOpen = window.drawerState.cartOpen;
  const wasUpsellOpen = window.drawerState.upsellOpen;

  window.drawerState = { ...newState };

  const cartDrawer = document.querySelector('cart-drawer');
  const upsellDrawer = document.getElementById('membership-upsell-drawer');
  const overlay = document.getElementById('CartDrawer-Overlay');

  cartDrawer?.classList.toggle('active', newState.cartOpen);
  upsellDrawer?.classList.toggle('active', newState.upsellOpen);
  upsellDrawer?.classList.toggle('hidden', !newState.upsellOpen);

  document.body.classList.toggle('drawer-open', newState.cartOpen || newState.upsellOpen);

  if (overlay) {
    overlay.style.display = (newState.cartOpen || newState.upsellOpen) ? 'block' : 'none';
  }

  console.log('[DrawerState] Applied:', newState);

  evaluateCTAVisibility(true);

  if (newState.upsellOpen) {
    bindUpsellButtons();
  }
}

function triggerInitialState() {
  const cartDrawer = document.querySelector('cart-drawer');
  const upsellDrawer = document.getElementById('membership-upsell-drawer');
  const cartOpen = cartDrawer?.classList.contains('active') || false;
  const upsellOpen = upsellDrawer?.classList.contains('active') || false;
  setDrawerState({ cartOpen, upsellOpen });
  evaluateCTAVisibility(true);
}

function bindUpsellButtons() {
  const upsellDrawer = document.getElementById('membership-upsell-drawer');
  if (!upsellDrawer) return;

  setTimeout(() => {
    upsellDrawer.querySelectorAll('.button.add').forEach(btn => {
      btn.onclick = null;
      btn.onclick = upsellHandler;
    });
    console.log('[Bind] Upsell buttons rebound');
  }, 300);
}

async function refreshCartSection() {
  try {
    const res = await fetch(window.location.pathname);
    const html = await res.text();
    const temp = document.createElement('div');
    temp.innerHTML = html;
    const newDrawer = temp.querySelector('cart-drawer');
    if (newDrawer) {
      const currentDrawer = document.querySelector('cart-drawer');
      currentDrawer.innerHTML = newDrawer.innerHTML;
      initDrawers();
      evaluateCTAVisibility(true);
      document.dispatchEvent(new CustomEvent('cart:updated'));
    }
  } catch (err) {
    console.error('[Refresh] Failed to refresh cart drawer:', err);
  }
}

async function upsellHandler(e) {
  e.preventDefault();
  const btn = e.currentTarget;
  const variantId = btn.dataset.variantId;
  if (!variantId) return;

  btn.disabled = true;
  btn.textContent = 'Adding...';
  try {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    });

    await refreshCartSection();
    setDrawerState({ cartOpen: true, upsellOpen: false });
  } catch (err) {
    console.error('[Upsell AddToCart] Failed', err);
  } finally {
    btn.disabled = false;
    btn.textContent = 'Add to Cart';
  }
}

function initDrawers() {
  const upsellDrawer = document.getElementById('membership-upsell-drawer');
  const cartDrawer = document.querySelector('cart-drawer');
  const overlay = document.getElementById('CartDrawer-Overlay');
  const cartDrawerCheckoutBtn = document.querySelector('#CartDrawer-Checkout');

  if (!upsellDrawer || !cartDrawer) return;

  document.querySelectorAll('.drawer__close').forEach(btn => {
    btn.addEventListener('click', () => {
      if (upsellDrawer.contains(btn)) {
        setDrawerState({ cartOpen: true, upsellOpen: false });
      } else {
        setDrawerState({ cartOpen: false, upsellOpen: false });
      }
    });
  });

  if (overlay) {
    console.log('[Overlay] Event listener attached');
    overlay.addEventListener('click', () => {
      console.log('[Overlay] Clicked');
      setDrawerState({ cartOpen: false, upsellOpen: false });
    });
  }

  if (cartDrawerCheckoutBtn) {
    cartDrawerCheckoutBtn.addEventListener('click', (e) => {
      e.preventDefault();
      console.log('[Checkout Button] Opening Upsell Drawer');
      setDrawerState({ cartOpen: true, upsellOpen: true });
    });
  }

  document.addEventListener('cart:updated', () => {
    console.log('[cart:updated] Triggered');
    const cartDrawer = document.querySelector('cart-drawer');
    const upsellDrawer = document.getElementById('membership-upsell-drawer');
    const cartOpen = cartDrawer?.classList.contains('active') || false;
    const upsellOpen = upsellDrawer?.classList.contains('active') || false;
    setDrawerState({ cartOpen, upsellOpen });
    evaluateCTAVisibility(true);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  hideFallbackCTA();

  const defaultCartButton = document.querySelector('[data-cart-trigger]');
  if (defaultCartButton) {
    defaultCartButton.addEventListener('click', () => {
      console.log('[Default Cart Button] Clicked');
      setDrawerState({ cartOpen: true, upsellOpen: false });
    });
  }

  initDrawers();
  triggerInitialState();
});

document.addEventListener('shopify:section:load', () => {
  initDrawers();
  bindUpsellButtons();
});

document.addEventListener('page:load', () => {
  initDrawers();
  bindUpsellButtons();
});

//End Drawer State Manager

function ensureFallbackContainer() {
  refreshGlobalElements();
  if (!fallbackContainer) {
    const parent = document.querySelector('#CartDrawer-CartItems');
    if (parent) {
      const newFallback = document.createElement('div');
      newFallback.id = 'fallback-cta';
      parent.appendChild(newFallback);
      console.log('[CheckoutHandler] Fallback CTA re-injected');
      refreshGlobalElements();
    }
  }
}

// ─────────────────────────────────────────
// 🔁 DOM Ready Initialization
// ─────────────────────────────────────────

document.addEventListener('DOMContentLoaded', () => {
  console.log('[CheckoutHandler] Initialized');
  refreshGlobalElements();
  ensureFallbackContainer();

  if (upsellDrawer && upsellDrawer.parentElement !== document.body) {
    document.body.appendChild(upsellDrawer);
    console.log('[UpsellDrawer] ✅ Moved to body');
  }

  document.querySelector('#membership-upsell-drawer .drawer-close')?.addEventListener('click', (e) => {
    e.preventDefault();
    if (upsellDrawer) {
      upsellDrawer.classList.remove('active');
      upsellDrawer.classList.add('hidden');
      document.body.classList.remove('drawer-open');
    }
  });

  bindInitialListeners();
  setTimeout(() => document.dispatchEvent(new CustomEvent('cart:updated')), 500);

  setupGlobalClickListener();
  observeCartItems(true);

  console.log('[CheckoutHandler] Script loaded completely');
});

function bindInitialListeners() {
  bindUpsellDrawerButtons(true);
  showFallbackCTAOnce();
}

function setupGlobalClickListener() {
  document.body.addEventListener('click', (e) => {
    const addBtn = e.target.closest('form[action^="/cart/add"] button[type="submit"], .ajax-add-to-cart');
    if (!addBtn) return;
    setTimeout(() => {
      console.log('[AddToCart] cart:updated dispatched and fallback CTA triggered');
      document.dispatchEvent(new CustomEvent('cart:updated'));
      fallbackDisplayed = false;
      showFallbackCTAOnce();
    }, 500);
  });
}

function throttledShowFallbackCTA() {
  if (fallbackCtaTimeout) return;
  fallbackCtaTimeout = setTimeout(() => {
    showFallbackCTAOnce();
    fallbackCtaTimeout = null;
  }, 500);
}

// ─────────────────────────────
// 🔽 Fallback Product Functions
// ─────────────────────────────

function showFallbackCTAOnce() {
  if (fallbackDisplayed) return;
  fallbackDisplayed = true;
  showFallbackCTA();
}

function getHeadline(option) {
  const headlines = {
    a: 'A Great Place To Start',
    b: 'NEW! Hot Item',
    c: 'Best Seller',
    d: 'Exclusive Deal',
    e: 'Hot Offer'
  };
  return `<h3 class="fallback-headline">${headlines[option] || 'Recommended Product'}</h3>`;
}

function createFallbackCard(product, option = 'a') {
  const variant = product.variants[0];
  const price = `$${(variant.price / 100).toFixed(2)}`;
  const productUrl = `/products/${product.handle}`;

  const ratingHtml =
    '<div class="fallback-star-rating">' +
    Array(5).fill('<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"></path></svg>').join('') +
    '</div>';

  return `
    <div class="fallback-headline-wrapper">
      <h3 class="fallback-headline">${getHeadline(option)}</h3>
    </div>
    <div class="fallback-product-card option-${option}">
      <div class="fallback-card-inner">
        <div class="fallback-image">
          <a href="${productUrl}">
            <img src="${product.featured_image}" alt="${product.title}" />
          </a>
        </div>
        <div class="fallback-content">
          <div class="fallback-top-content">
            ${ratingHtml}
            <h3 class="fallback-title">
              <a href="${productUrl}">${product.title}</a>
            </h3>
            <div class="fallback-price">${price}</div>
          </div>
          <button type="button" class="fallback-button" data-variant-id="${variant.id}">Add to Cart</button>
        </div>
      </div>
    </div>`;
}

function applyFallbackStyles() {
  if (!fallbackContainer) return;
  fallbackContainer.classList.add('fallback-ready');
  fallbackContainer.style.display = 'block';
  fallbackContainer.style.visibility = 'visible';
  fallbackContainer.style.opacity = '1';
}

function bindFallbackButtons() {
  document.querySelectorAll('.fallback-button').forEach(originalButton => {
    const button = originalButton.cloneNode(true);
    originalButton.replaceWith(button); // Replace and bind the new node

    button.addEventListener('click', async () => {
      const variantId = button.dataset.variantId;
      if (!variantId) return;

      button.disabled = true;
      button.textContent = 'Adding...';

      try {
        // Step 1: Add item to cart
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
        });

        // Step 2: Refresh the drawer HTML
        await refreshCartDrawer(); // ⬅️ This is what triggers the DOM update

        // Step 3: Let the user know it worked
        button.textContent = 'Added!';
      } catch (err) {
        console.error('[Fallback] ❌ Failed to add:', err);
        button.textContent = 'Error';
      } finally {
        button.disabled = false;
      }
    });
  });
}


function showFallbackCTA() {
  refreshGlobalElements();
  ensureFallbackContainer();
  console.log('→ showFallbackCTA called');
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const existingHandles = cart.items.map(i => i.handle);
      const tags = ['fallback-a', 'fallback-b', 'fallback-c', 'fallback-d', 'fallback-e'];
      (async function checkTags() {
        for (const tag of tags) {
          const tagKey = tag.split('-')[1];
          const tagRes = await fetch(`/search?q=tag:${tag}&view=json`);
          const products = await tagRes.json();
          const product = products.find(p => !existingHandles.includes(p.handle));
          if (product && fallbackContainer) {
            fallbackContainer.innerHTML = createFallbackCard(product, tagKey);
            bindFallbackButtons();
            bindCheckoutButton(true);
            break;
          }
        }
      })();
    });
}

  // ─────────────────────────────
  // 🔽 Checkout + Cart Functions
  // ─────────────────────────────

function observeCartItems(forceReconnect = false) {
  refreshGlobalElements();

  if (!cartDrawer) {
    console.warn('[Observer] Cart drawer not found, retrying...');
    setTimeout(() => observeCartItems(forceReconnect), 500);
    return;
  }

  if (cartItemsObserver && !forceReconnect) return;

  if (cartItemsObserver) cartItemsObserver.disconnect();

  cartItemsObserver = new MutationObserver(() => {
    const currentCount = cartDrawer.querySelectorAll('.cart-item').length;
    if (currentCount === lastCartItemCount) return;

    lastCartItemCount = currentCount;
    console.log('[Observer] Actual cart change detected');
    refreshGlobalElements();
    ensureFallbackContainer();
    fallbackDisplayed = false;
    bindFallbackButtons();
    bindCheckoutButton(true);
    bindUpsellDrawerButtons(true);
    showFallbackCTAOnce();
  });

  cartItemsObserver.observe(cartDrawer, { childList: true, subtree: true });
  bindCheckoutButton(true);
  bindUpsellDrawerButtons(true);
}

async function refreshCartDrawer() {
  console.log('[refreshCartDrawer] Fetching updated cart sections...');

  try {
    const res = await fetch('/?sections=cart-drawer,cart-icon-bubble');
    const data = await res.json();

    console.log('[refreshCartDrawer] Fetched sections:', data);

    const drawerComponent = document.querySelector('cart-drawer');

    if (drawerComponent && typeof drawerComponent.updateWithParsedSections === 'function') {
      console.log('[refreshCartDrawer] Using updateWithParsedSections');
      drawerComponent.updateWithParsedSections(data);

      // ✅ Keep drawer open after refresh
      setDrawerState({ cartOpen: true, upsellOpen: false });
    } else {
      // Fallback if drawer component fails
      const drawerWrapper = document.querySelector('#CartDrawer');
      const bubbleWrapper = document.querySelector('#cart-icon-bubble');

      if (drawerWrapper && data['cart-drawer']) {
        const parsedDrawer = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
        drawerWrapper.innerHTML = parsedDrawer.querySelector('#CartDrawer')?.innerHTML || '';
      }

      if (bubbleWrapper && data['cart-icon-bubble']) {
        const parsedBubble = new DOMParser().parseFromString(data['cart-icon-bubble'], 'text/html');
        bubbleWrapper.innerHTML = parsedBubble.querySelector('#cart-icon-bubble')?.innerHTML || '';
      }

      // ✅ Keep drawer open after fallback refresh
      setDrawerState({ cartOpen: true, upsellOpen: false });
    }

    // ✅ Notify other scripts of updated cart
    requestAnimationFrame(() => {
      console.log('[refreshCartDrawer] Dispatching cart:updated');
      document.dispatchEvent(new CustomEvent('cart:updated'));
    });
  } catch (err) {
    console.error('[refreshCartDrawer] ❌ Failed to fetch and update cart drawer:', err);
  }
}

function detectCheckoutButton(retries = 10) {
  const button = document.querySelector('[data-checkout-trigger], #CartDrawer-Checkout, .checkout-button');
  if (button) {
    bindCheckoutButton(true);
  } else if (retries > 0) {
    setTimeout(() => detectCheckoutButton(retries - 1), 300);
  }
}

function bindCheckoutButton(forceRebind = false) {
  const button = document.querySelector('[data-checkout-trigger], #CartDrawer-Checkout, .checkout-button');
  if (!button) return;
  if (!forceRebind && button._boundClickAttached) return;
  button.removeEventListener('click', button._boundClick);
  button._boundClick = async function (e) {
    e.preventDefault();
    refreshGlobalElements();
    await new Promise(resolve => setTimeout(resolve, 300));
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const tagChecks = await Promise.all(
        cart.items.map(async (item) => {
          try {
            const prodRes = await fetch(`/products/${item.handle}.js`);
            const prodData = await prodRes.json();
            const normalizedTags = prodData.tags.map(t => t.toLowerCase().trim());
            return normalizedTags.includes('free shipping');
          } catch (err) {
            console.warn(`[bindCheckoutButton] Error checking product "${item.handle}":`, err);
            return false;
          }
        })
      );
      const hasFreeShipping = tagChecks.some(Boolean);
      const products = getProductsFromDOM();
      if (Object.keys(products).length === 0) {
        cart.items.forEach(item => {
          const id = item.variant_id;
          if (id) products[id] = (products[id] || 0) + item.quantity;
        });
      }
      const urlLineItems = Object.entries(products).map(([id, qty]) => `${id}:${qty}`).join(';');
      if (!hasFreeShipping && !upsellHandled) {
        upsellDrawer?.classList.remove('hidden');
        upsellDrawer?.classList.add('active');
        document.body.classList.add('drawer-open');
        return;
      }
      window.location.href = hasFreeShipping
        ? `https://secure.possibletraining.com/checkout-free-shipping-cart?products=${urlLineItems}&cartId=${getCartCookie('cart')}`
        : '/checkout';
    } catch (err) {
      window.location.href = '/checkout';
    }
  };
  button.addEventListener('click', button._boundClick);
  button._boundClickAttached = true;
}

function bindUpsellDrawerButtons(forceRebind = false) {
  document.querySelectorAll('.decline-offer, .continue-checkout').forEach(button => {
    button.removeEventListener('click', button._boundClick);
    button._boundClick = e => {
      e.preventDefault();
      upsellHandled = true;
      window.location.href = '/checkout';
    };
    button.addEventListener('click', button._boundClick);
  });

  const upsellAddButton = upsellDrawer?.querySelector('button.add');
  if (upsellAddButton && (!upsellAddButton._bound || forceRebind)) {
    upsellAddButton._bound = true;
    upsellAddButton.removeEventListener('click', upsellAddButton._boundClick);
    upsellAddButton._boundClick = async function (e) {
      e.preventDefault();
      const variantId = this.dataset.variantId;
      const sellingPlanId = this.dataset.sellingPlanId || '21459959844';
      if (!variantId) return;
      this.disabled = true;
      this.textContent = 'Adding...';
      try {
        const payload = {
          id: parseInt(variantId, 10),
          quantity: 1,
          ...(sellingPlanId ? { selling_plan: sellingPlanId } : {})
        };
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify(payload)
        });
        await refreshCartDrawer();
        upsellDrawer.classList.remove('active');
        upsellDrawer.classList.add('hidden');
        document.body.classList.remove('drawer-open');
        upsellHandled = true;
      } catch (error) {
        console.error('[UpsellDrawer] ❌ Failed to add item:', error);
      } finally {
        this.disabled = false;
        this.textContent = 'Add to Cart';
      }
    };
    upsellAddButton.addEventListener('click', upsellAddButton._boundClick);
  }
}

async function continueToCheckout() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    const tagChecks = await Promise.all(cart.items.map(async (item) => {
      try {
        const prodRes = await fetch(`/products/${item.handle}.js`);
        const prodData = await prodRes.json();
        const normalizedTags = prodData.tags.map(t => t.toLowerCase().trim());
        return normalizedTags.includes('free shipping');
      } catch (err) {
        console.warn(`[TagCheck] ⚠️ Failed to fetch product for handle: ${item.handle}`, err);
        return false;
      }
    }));
    const hasFreeShipping = tagChecks.some(Boolean);
    let products = getProductsFromDOM();
    if (Object.keys(products).length === 0) {
      products = {};
      cart.items.forEach(item => {
        const id = item.variant_id;
        if (id) products[id] = (products[id] || 0) + item.quantity;
      });
    }
    const cartId = getCartCookie('cart');
    const urlLineItems = Object.entries(products).map(([id, qty]) => `${id}:${qty}`).join(';');
    const redirectUrl = hasFreeShipping
      ? `https://secure.possibletraining.com/checkout-free-shipping-cart?products=${urlLineItems}&cartId=${cartId}`
      : '/checkout';
    if (!hasFreeShipping && !upsellHandled) {
      upsellDrawer?.classList.remove('hidden');
      upsellDrawer?.classList.add('active');
      document.body.classList.add('drawer-open');
      return;
    }
    upsellHandled = true;
    window.location.href = redirectUrl;
  } catch (err) {
    console.error('[Redirect] ❌ Error during checkout:', err);
    window.location.href = '/checkout';
  }
}

function getProductsFromDOM() {
  const metafields = document.querySelectorAll('.konnektive-metafield');
  const products = {};
  metafields.forEach(el => {
    const productId = el.dataset.productId;
    const quantity = parseInt(el.dataset.quantity || '1', 10);
    if (productId) {
      products[productId] = (products[productId] || 0) + quantity;
    }
  });
  return products;
}

function getCartCookie(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? match[2] : '';
}

window.hideMembershipUpsellDrawer = function () {
  if (upsellDrawer) {
    upsellDrawer.classList.remove('active');
    upsellDrawer.classList.add('hidden');
    document.body.classList.remove('drawer-open');
    upsellHandled = true;
    window.location.href = '/checkout';
  }
};

// ─────────────────────────────
// 🔽 Custom Event Listeners
// ─────────────────────────────

document.addEventListener('cart:updated', () => {
  console.log('[Event] cart:updated triggered');
  ensureFallbackContainer();
  refreshGlobalElements();
  fallbackDisplayed = true;
  bindFallbackButtons();
  throttledShowFallbackCTA();
  observeCartItems(true);
});
}